import app from './app.js'
import name from './name.js'

const config = Object.assign(
  app,
  name
)

export default config;
